import { filterConfig } from "../Global.types"

export const PENDINGTPVLISTCONFIGS = [
  {
    headerName: 'Customer Name',
    apiFieldNameFirst: 'cusFirstName',
    apiFieldNameSecond: 'cusLastName',
    columnWidth: '150',
    type: 'SPACE_SEPERATED',
  },
  {
    headerName: 'Agent Name',
    apiFieldName: 'agentFirstName',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Type',
    apiFieldName: 'tpvType',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Sales Channel',
    apiFieldName: 'salesChannelName',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'TPV Status',
    apiFieldName: 'tpvStatus',
    columnWidth: '150',
    type: 'STATUS_BADGE',
  },
  {
    headerName: 'UAN',
    apiFieldName: 'uan',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Utility',
    apiFieldName: 'utility',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Brand Name',
    apiFieldName: 'brandName',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Product Name',
    apiFieldName: 'productName',
    columnWidth: '150',
    type: 'TEXT',
  },
]

//keyshouldbeapifieldName
export const PENDINGTPVLISTFILTERCONFIG: filterConfig[] = [
  {
    key: 'tpvStatus',
    label: 'TPV Status',
    type:"STRING",
    options: [
      {
        value: '',
        
        name: 'Select an option',
      },
      {
        value: 'FAILED',
        name: 'Failed',
      },
      {
        value: 'INCOMPLETE',
        name: 'Incomplete',
      },
      {
        value: 'PASSED',
        name: 'Passed',
      },
      {
        value: 'PENDING',
        name: 'Pending',
      },
    ],
  },
]